module.exports = __webpack_public_path__ + "img/enzo-q.bb65d941a56823221dee6b9db4c96120.png";